import React from "react";

const PassInput = props => {

    return (
        <input type="password" className={"input " + props.className} onChange={e => props.set(e.target.value)} value={props.v} />
    );
}

export default PassInput;